export const REDUX_INIT = "@@redux/INIT";

export const SET_VOD_URL = "SET_VOD_URL";
export const SET_VOD_APPIDENTIFIER = "SET_VOD_APPIDENTIFIER";
export const SET_VOD_APIVERSION = "SET_VOD_APIVERSION";
export const SET_VOD_PAYMENTENABLED = "SET_VOD_PAYMENTENABLED";
export const SET_VOD_DEMOSYSTEM = "SET_VOD_DEMOSYSTEM";
export const SET_VOD_USEWITHCREDENTIALS = "SET_VOD_USEWITHCREDENTIALS";